import React from 'react';

export const MAX_QUANTITY_TOOLTIP = 'Обрано максимальну кількість, більше немає в наявності';

export const formatPrice = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');


export const renderUnitPrice = (product, formatPriceFn = formatPrice) => {
  const price = product.price;
  const discountedPrice = product.discountedPrice;
  const hasDiscount = discountedPrice !== price;

  if (hasDiscount) {
    return (
      <span style={{ fontSize: '1rem' }}>
        <span style={{ color: '#999', textDecoration: 'line-through', whiteSpace: 'nowrap' }}>{formatPriceFn(price)} грн</span>
        {' '}
        <span style={{ fontWeight: 400, whiteSpace: 'nowrap' }}>{formatPriceFn(discountedPrice)} грн</span>
      </span>
    );
  }
  return (
    <span style={{ fontSize: '1rem', fontWeight: 400, whiteSpace: 'nowrap' }}>
      {formatPriceFn(price)} грн
    </span>
  );
};

export const renderTotalPrice = (product, formatPriceFn = formatPrice) => {
  const total = product.discountedPrice * product.quantity;
  return (
    <span style={{ fontSize: '1rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
      {formatPriceFn(total)} грн
    </span>
  );
};
